import { render, staticRenderFns } from "./ShareMoreLastDialog.vue?vue&type=template&id=03857855"
import script from "./ShareMoreLastDialog.vue?vue&type=script&lang=js"
export * from "./ShareMoreLastDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareMoreLastDialog.vue?vue&type=style&index=0&id=03857855&prod&lang=scss"
import style1 from "./ShareMoreLastDialog.vue?vue&type=style&index=1&id=03857855&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports